_getUserEmailAvailabilityThunk